import { Controller, useFormContext } from 'react-hook-form';
import { Building07 } from '@untitledui/icons';
import { Input } from '@/components/base/input/input';
import { AUTH_FORM_SIZE } from '@/shared/config/auth-form';
import type { SignupFormValues } from '../schema';

export const Step06Empresa = () => {
  const {
    control,
    formState: { errors },
  } = useFormContext<SignupFormValues>();

  return (
    <Controller
      control={control}
      name="empresa"
      render={({ field }) => (
        <Input
          label="Empresa"
          type="text"
          size={AUTH_FORM_SIZE}
          icon={Building07}
          placeholder="Nome da empresa"
          autoComplete="organization"
          autoFocus
          isInvalid={!!errors.empresa}
          hint={errors.empresa?.message}
          value={field.value ?? ''}
          onChange={field.onChange}
          onBlur={field.onBlur}
          name={field.name}
        />
      )}
    />
  );
};
